import React, { Component } from 'react';
import { IonButton, IonIcon } from '@ionic/react';
import { filter } from 'ionicons/icons';
import { withTranslation } from '../../lib/translate';
import { NormalText, Spacer, Subtitle } from '../common';
import './index.css';

class NoFilterResults extends Component {
	render() {
		const { __, openFilters } = this.props;
		return (
			<div className="no-filter-results">
				<div className="no-filter-results-icon">
					<IonIcon icon={filter} />
				</div>
				<Subtitle className="block">{__('No items match your selected filters')}</Subtitle>

				<NormalText className="block">{__('Please refine your search or filters to see more dishes and drinks.')}</NormalText>
				<Spacer size={2} />
				<IonButton className="no-filter-results-button" color="primary" onClick={openFilters}>
					{__('Open filters')}
				</IonButton>
			</div>
		);
	}
}

export default withTranslation(NoFilterResults);
